import { Area, AreaChart, ResponsiveContainer } from 'recharts';
import { palette } from './chartTheme';

interface SparklineProps {
  data: { value: number }[];
  height?: number;
  tone?: 'primary' | 'success' | 'danger' | 'info' | 'warning';
}

const TONE_VAR: Record<NonNullable<SparklineProps['tone']>, string> = {
  primary: 'primary',
  success: 'success',
  danger: 'danger',
  info: 'info',
  warning: 'warning',
};

export function Sparkline({ data, height = 36, tone = 'primary' }: SparklineProps) {
  const color = `hsl(var(--${TONE_VAR[tone]}))`;
  if (!data?.length) return <div style={{ height }} />;
  return (
    <div style={{ height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={data} margin={{ top: 2, right: 0, left: 0, bottom: 0 }}>
          <defs>
            <linearGradient id={`spark-${tone}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.32} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#spark-${tone})`}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
      <span className="sr-only">{palette.primary.name}</span>
    </div>
  );
}
